import React, { useEffect, useState } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { copyToClipboard } from '../copyToClipboard';
import { insertIntoLabTerminal, isCommandLanguage, isLabTerminalOpen, LAB_STATE_EVENT } from '../labCommands';

// Текст из React-дерева блока кода (rehype-highlight разбивает его на вложенные span).
const textOf = (node) => {
    if (node == null || typeof node === 'boolean') return '';
    if (typeof node === 'string' || typeof node === 'number') return String(node);
    if (Array.isArray(node)) return node.map(textOf).join('');
    return textOf(node.props && node.props.children);
};

// Блок кода в тексте лекции: кнопка «Копировать», а у команд оболочки — «Вставить в терминал»
// (если рядом открыт лабораторный терминал; команда вставляется без Enter — её можно поправить).
const CodeBlock = ({ children, preProps }) => {
    const code = React.Children.toArray(children)[0];
    const className = (code && code.props && code.props.className) || '';
    const text = textOf(code && code.props && code.props.children).replace(/\n$/, '');
    const command = isCommandLanguage(className);

    const [terminalOpen, setTerminalOpen] = useState(isLabTerminalOpen());
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        const update = () => setTerminalOpen(isLabTerminalOpen());
        window.addEventListener(LAB_STATE_EVENT, update);
        return () => window.removeEventListener(LAB_STATE_EVENT, update);
    }, []);

    const plain = command ? text.split('\n').map((line) => line.replace(/^\$ /, '')).join('\n') : text;

    return (
        <Box sx={{ position: 'relative' }}>
            <pre {...preProps}>{children}</pre>
            <Box sx={{ position: 'absolute', top: 6, right: 6, display: 'flex', gap: 0.5 }}>
                {command && terminalOpen && (
                    <Tooltip title="Вставить в терминал">
                        <IconButton
                            size="small"
                            onClick={() => insertIntoLabTerminal(plain)}
                            sx={{ bgcolor: 'rgba(0,0,0,0.55)', color: '#7ee787', '&:hover': { bgcolor: 'rgba(0,0,0,0.75)' } }}
                        >
                            <PlayArrowIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                )}
                <Tooltip title={copied ? 'Скопировано' : 'Копировать'}>
                    <IconButton
                        size="small"
                        onClick={() => {
                            copyToClipboard(plain);
                            setCopied(true);
                            setTimeout(() => setCopied(false), 1500);
                        }}
                        sx={{ bgcolor: 'rgba(0,0,0,0.55)', color: '#e6edf3', '&:hover': { bgcolor: 'rgba(0,0,0,0.75)' } }}
                    >
                        {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
                    </IconButton>
                </Tooltip>
            </Box>
        </Box>
    );
};

export default CodeBlock;
